
import { Options, Vue } from 'vue-class-component';
import { collectionQuestion, addWrongQuestion, cancelWrongQuestion } from "@/api/index";
import { getCurrentInstance } from "vue";
import { isNewBridgeView } from '@/assets/js/utils.js'
import { nativeToast, nativeConfirm } from '@/utils/nativeFn'

@Options({
  props: {
    questionData: {
      type: Object,
      default() {
        return {}
      }
    },
    isList: {
      type: Boolean,
      default: false
    },
    showKnowledgePoint: {
      type: Boolean,
      default: false
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    isWrongQuestion: {
      type: Boolean,
      default: false
    },
    source:{
      type: String,
      default:""
    }
  },
  watch: {
    questionData(newVal, oldVal) {
      this.isShowMore = false
      this.renderQuestion()
    }
  },
  emits: ['reportAction']
})
export default class QuestionDetail extends Vue {
  isList
  isShowMore: boolean = false
  knowledgePoint: any[] = []
  collecting: boolean = false
  isAjaxing: boolean = false
  $xesLog = getCurrentInstance()?.appContext.config.globalProperties.$xesLog
  mounted() {
    this.renderQuestion()
  }
  // 加入错题本
  addWrongList(nry_question_id) {
    if (this.isAjaxing) {
      return
    }
    let params = {
      nry_question_id
    }
    this.isAjaxing = true
    addWrongQuestion(params).then((res) => {
      this.isAjaxing = false
      if (res.data.code !== 0 && res.data.code !== 100901) {
        this.$toast.fail(res.data.message)
        return
      }
      (this as any).questionData.is_wrong_question = true;
      this.$toast.success('加入成功')
    }).catch((err) => {
      this.isAjaxing = false
      console.log(err)
    })
    this.$emit('reportAction', 'add_into_notebook')
  }
  // 移出错题本
  cancelWrongQuestion(nry_question_id) {
    if (this.isAjaxing) {
      return
    }
    let params = {
      nry_question_id
    }
    this.isAjaxing = true
    cancelWrongQuestion(params).then((res) => {
      this.isAjaxing = false
      if (res.data.code !== 0  && res.data.code !== 100902) {
        this.$toast.fail(res.data.message)
        return
      }
      (this as any).questionData.is_wrong_question = false;
      this.$toast.success('移出成功')
    }).catch((err) => {
      this.isAjaxing = false
      console.log(err)
    })
    this.$emit('reportAction', 'remove_notebook')
  }
  // 收藏/取消收藏
  collectionQuestion() {
    if (this.collecting) {
      return
    }
    let data = (this as any).questionData;
    let nry_question_id = data.nry_question_id
    let action = data.collection? 1: 0
    let successToastTxt = (action === 0 ? '收藏成功': '取消成功');
    let failToastTxt = (action === 0 ? '收藏失败': '取消失败');
    let serviceVersion = localStorage.getItem('service_version')? Number(localStorage.getItem('service_version')): 0
    
    let params = {
      nry_question_id,
      action
    }
    this.collecting = true
    collectionQuestion(params).then((res) => {
      this.collecting = false
      if(res.data.code !== 0) {
        this.$toast.fail(res.data.message)
        return
      }


      if((this as any).source === "compareAnswer"){
        this.$xesLog.track('oneself_check_page_exer_ana_add_favorite_click', {
          biz_name:'paipai',
          page_name:'自己对答案',
          event_name:'自己对答案页-『题目解析』浮层-『添加收藏』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'oneself_check_page',
          exer_status: action === 0 ? 'add_into_favorite' : 'remove_favorite',
        })
      }else if((this as any).source === "show_scan_result_frequency_page"){
        this.$xesLog.track('que_ans_click', {
          biz_name:'int_lear',
          page_name:'视频扫码结果',
          event_name:'视频扫码结果页-『题目解析』浮层-『添加收藏』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'show_scan_result_frequency_page',
          exer_status: action === 0 ? 'add_into_favorite' : 'remove_favorite',
        })
      }else if((this as any).source === "pho_check_page"){
        this.$xesLog.track('pho_check_page_exer_ana_add_favorite_click', {
          biz_name:'paipai',
          page_name:'拍照批改页',
          event_name:'拍照批改页-『题目解析』浮层-『添加收藏』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:nry_question_id,
          exer_status: action === 0 ? 'add_into_favorite' : 'remove_favorite',
          source_location:'pho_check_page'
        })
      }else if((this as any).source === "favorite_notebook"){
        this.$xesLog.track('favorite_notebook_click', {
          biz_name:'int_lear',
          page_name:'收藏夹',
          event_name:'收藏夹-『题目解析』浮层-『添加收藏』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:nry_question_id,
          exer_status: action === 0 ? 'add_into_favorite' : 'remove_favorite',
          source_location:'favorite_notebook'
        })
      }else{
        this.$xesLog.track('que_ans_click', {
          biz_name:'',
          page_name:'',
          event_name:'题目解析』浮层-『添加收藏』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:nry_question_id,
          exer_status: action === 0 ? 'add_into_favorite' : 'remove_favorite',
          source_location:'null_source'
        })
      }

      (this as any).questionData.collection = action === 0;
      let hascollectioned = localStorage.getItem('hascollectioned')
      if (!hascollectioned && action === 0) {
        localStorage.setItem('hascollectioned', '1')
        if (isNewBridgeView()) {
          nativeConfirm({
            message: '收藏的题目可以在「我的」-「智能推荐收藏夹」中进行查看题目和解析哦。',
            confirmButtonText: '我知道了'
          }, (res) => {
            console.log('native confirm', res)
          })
          return
        }
        if (serviceVersion > 6) {
          window['$mobileNativeSDK'].nativeConfirm({
            message: '收藏的题目可以在「我的」-「智能推荐收藏夹」中进行查看题目和解析哦。',
            buttonTxt: '我知道了'
          })
        } else {
          this.$dialog.alert({
            message: '收藏的题目可以在「我的」-「智能推荐收藏夹」中进行查看题目和解析哦。',
            confirmButtonText: '我知道了'
          })
        }
        return
      }
      if (isNewBridgeView()) {
        nativeToast(successToastTxt)
        return
      }
      if (serviceVersion > 6) {
        window['$mobileNativeSDK'].nativeToast({
          message: successToastTxt,
          timer: '1'
        })
      } else {
        this.$toast.success(successToastTxt)
      }
    }).catch((err) => {
      this.collecting = false
      if (isNewBridgeView()) {
        nativeToast(failToastTxt)
        return
      }
      if (serviceVersion > 6) {
        window['$mobileNativeSDK'].nativeToast({
          message: failToastTxt,
          timer: '1'
        })
      } else {
        this.$toast.success(failToastTxt)
      }
    })
  }
  //展开解析
  viewAnalysis() {
    this.isShowMore = !this.isShowMore
    if (this.isShowMore) {
      // 点击埋点
      // this.$xesLog.track('que_ans_click', {
      //   biz_name: 'int_lear',
      //   event_type: 'click',
      //   check_ans: 'check_ans',
      //   event_name: '错题解析-功能点击'
      // })
      if((this as any).source === "compareAnswer"){
        this.$xesLog.track('oneself_check_page_exer_ana_check_ans_click', {
          biz_name:'paipai',
          page_name:'自己对答案',
          source_location:'oneself_check_page',
          event_type: 'click',
          event_name: '自己对答案页-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          nry_question_id:(this as any).questionData.nry_question_id,
          check_ans:'check_ans',
        })
      }else if((this as any).source === "show_scan_result_frequency_page"){
        this.$xesLog.track('que_ans_click', {
          biz_name:'int_lear',
          page_name:'视频扫码结果',
          source_location:'show_scan_result_frequency_page',
          event_type: 'click',
          event_name: '视频扫码结果-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          nry_question_id:(this as any).questionData.nry_question_id,
          check_ans:'check_ans'
        })
      }else if((this as any).source === "pho_check_page"){
        this.$xesLog.track('pho_check_page_exer_ana_check_ans_click', {
          biz_name:'paipai',
          page_name:'拍照批改页',
          event_name:'拍照批改页-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'pho_check_page',
          check_ans:'check_ans'
        })
      }else if((this as any).source === "favorite_notebook"){
          this.$xesLog.track('favorite_notebook_click', {
            biz_name:'int_lear',
            page_name:'收藏夹',
            event_name:'『题目解析』浮层-『查看题目解析』按钮点击（H5）',
            event_type: 'click',
            nry_question_id:(this as any).questionData.nry_question_id,
            source_location:'favorite_notebook',
            check_ans:'check_ans'
          })
        }else{
        this.$xesLog.track('recom_click', {
          biz_name:'',
          page_name:'',
          event_name:'『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'null_source',
          check_ans:'check_ans'
        })
      }
    }else{
      if((this as any).source === "compareAnswer"){
        this.$xesLog.track('oneself_check_page_exer_ana_check_ans_click', {
          biz_name:'paipai',
          page_name:'自己对答案',
          source_location:'oneself_check_page',
          event_type: 'click',
          event_name: '自己对答案页-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          nry_question_id:(this as any).questionData.nry_question_id,
          check_ans:'close_ans'
        })
      }else if((this as any).source === "show_scan_result_frequency_page"){
        this.$xesLog.track('recom_click', {
          biz_name:'int_lear',
          page_name:'视频扫码结果',
          source_location:'show_scan_result_frequency_page',
          event_type: 'click',
          event_name: '视频扫码结果-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          nry_question_id:(this as any).questionData.nry_question_id,
          check_ans:'close_ans'
        })
      }else if((this as any).source === "pho_check_page"){
        this.$xesLog.track('pho_check_page_exer_ana_check_ans_click', {
          biz_name:'paipai',
          page_name:'拍照批改页',
          event_name:'拍照批改页-『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'pho_check_page',
          check_ans:'close_ans'
        })
      }else if((this as any).source === "favorite_notebook"){
          this.$xesLog.track('favorite_notebook_click', {
            biz_name:'int_lear',
            page_name:'收藏夹',
            event_name:'『题目解析』浮层-『查看题目解析』按钮点击（H5）',
            event_type: 'click',
            nry_question_id:(this as any).questionData.nry_question_id,
            source_location:'favorite_notebook',
            check_ans:'close_ans'
          })
        }else{
        this.$xesLog.track('recom_click', {
          biz_name:'',
          page_name:'',
          event_name:'『题目解析』浮层-『查看题目解析』按钮点击（H5）',
          event_type: 'click',
          nry_question_id:(this as any).questionData.nry_question_id,
          source_location:'null_source',
          check_ans:'close_ans'
        })
      }
    }
    
  }
  // 渲染题目信息
  renderQuestion() {
    let data = (this as any).questionData;
    let questionIndex = (this as any).questionIndex;
    if (this.isList && data.labels.length > 6) {
      let tempArr = [...data.labels]
      this.knowledgePoint = tempArr.splice(0, 6)
    } else {
      this.knowledgePoint = data.labels
    }
    this.$nextTick(() => {
      let questionTitleDom: any = document.getElementById(`questionTitle_${questionIndex}`);
      let questionAnalysisDom: any = document.getElementById(`questionAnalysis_${questionIndex}`);
      let questionAnswerDom: any = document.getElementById(`questionAnswer_${questionIndex}`);
      // let questionCalloutDom: any = document.getElementById(`questionCallout_${questionIndex}`);
      try {
        // questionTitleDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('question', data.question_detail, {
        //   hideDifficulty: true,
        //   hideSource: true,
        //   hideCamera: true,
        // });
        questionTitleDom.innerHTML = (window as any).TalqsTemplate.render(data.question_detail, {
          hideDifficulty: true,
          hideSource: true,
          hideCamera: true,
        });
        (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionTitleDom]);
        if (!this.isList) {
          questionAnalysisDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionAnalyze', data.question_detail, {
            hideDifficulty: true,
            hideSource: true,
            hideCamera: true,
          });
          questionAnswerDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionAnswer', data.question_detail, {
            hideDifficulty: true,
            hideSource: true,
            hideCamera: true,
          });
          // questionCalloutDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionKnowledgePoint', data.question_detail, {
          //   analyzeVersion: 2,
          //   showLabelKnow: true,
          //   excludeLogicToAutoLayout: [],
          // });
          (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionAnalysisDom]);
          (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionAnswerDom]);
          // (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionCalloutDom]);
        }
        (window as any).TalqsTemplate.autoLayout();
      } catch (e) {
        console.log('error', e);
      }
    });
  }
}
